export const baseURL = "https://admin.skrollapp.com/";
export const secretKey = "5TIvw5cpc0";
export const projectName = "Skroll";
export const folderStructurePath = "Skroll";
